"use client";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { AeroDown } from "@/utlility/icons";
// import { colors } from "@/app/Colors";
import { usePathname, useRouter } from "next/navigation";

const NavigationDropdown = ({
  title,
  content,
  href,
  market_area,
  default_market_area,
  category,
  className = "",
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const currentPath = usePathname();
  const pathParts = currentPath.split("/").filter(Boolean);
  const isMarketArea = market_area?.some((item) => pathParts.includes(item));
  const activeMarketArea = isMarketArea ? pathParts[0] : null;
  const targetCategoryPath = activeMarketArea
    ? `/${activeMarketArea}/${href}-in-${activeMarketArea}`
    : `/${href}-in-${default_market_area?.slug}`;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setIsDropdownOpen(false);
  }, [currentPath]);

  const handleToggle = (nextShow) => {
    if (isMobile) {
      setIsDropdownOpen(nextShow);
    }
  };

  const handleToggleClick = (e) => {
    if (isMobile) {
      e.preventDefault();
      setIsDropdownOpen(!isDropdownOpen);
    }
  };

  return (
    <Dropdown
      show={isMobile ? isDropdownOpen : true}
      onToggle={handleToggle}
      className={className}
    >
      <Dropdown.Toggle
        id={category?.category_slug}
        className="nav-btn"
        onClick={handleToggleClick}
      >
        <Link
          href={targetCategoryPath.replace(/\/$/, "")}
          className={`nav-link ${className?.includes("active") ? "active" : ""}`}
          onClick={(e) => isMobile && e.stopPropagation()}
        >
          {title}
        </Link>
        <i className="icon">
          <AeroDown />
        </i>
      </Dropdown.Toggle>
      <Dropdown.Menu className="m-0 pt-lg-1">
        <div className="menu-cover">
          {content?.map((subCategoryName, index) => {
            const subCategory = category.sub_categories.find(
              (item) => item.category_name === subCategoryName
            );

            const targetSubCategoryPath = activeMarketArea
              ? `/${activeMarketArea}/${subCategory?.category_slug}-in-${activeMarketArea}`
              : `/${subCategory?.category_slug}-in-${default_market_area?.slug}`;

            return (
              <Dropdown.Item
                as={Link}
                key={index}
                className={`drop-item ${currentPath === targetSubCategoryPath.replace(/\/$/, "") ? "active" : ""}`}
                href={targetSubCategoryPath.replace(/\/$/, "")}
              >
                {subCategoryName}
              </Dropdown.Item>
            );
          })}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default NavigationDropdown;
